module.exports = __webpack_public_path__ + "img/notary-journal_B09HH7QVDR.740e441e.jpg";